import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from '../utils/i18n';
import { ArrowLeft, MessageCircle, Phone } from 'lucide-react';
import './ComingSoonPage.css';

const ComingSoonPage = () => {
  const navigate = useNavigate();
  const { language } = useAuth();
  const { t } = useTranslation(language);

  const ADMIN_PHONE = '01083511179';
  const KAKAO_CHAT_URL = 'https://open.kakao.com/o/your-kakao-link'; // Replace with actual Kakao chat link

  const handlePhoneCall = () => {
    window.location.href = `tel:${ADMIN_PHONE}`;
  };

  const handleKakaoChat = () => {
    window.open(KAKAO_CHAT_URL, '_blank');
  };

  return (
    <div className="coming-soon-page">
      <div className="page-header">
        <button className="btn-back" onClick={() => navigate('/')}>
          <ArrowLeft size={20} />
        </button>
        <h1 className="page-title">{t('comingSoon')}</h1>
      </div>

      <div className="page-content">
        <div className="coming-soon-container">
          {/* Main Icon */}
          <div className="coming-soon-icon">
            <span role="img" aria-label="construction">🚧</span>
          </div>

          {/* Title */}
          <h2 className="coming-soon-title">
            {t('comingSoonTitle')}
          </h2>

          {/* Description */}
          <p className="coming-soon-description">
            {t('comingSoonDescription')}
          </p>

          {/* Contact Section */}
          <div className="contact-section">
            <h3 className="contact-title">
              {t('contactUs')}
            </h3>

            <div className="contact-buttons">
              {/* Kakao Chat Button */}
              <button className="contact-btn kakao-btn" onClick={handleKakaoChat}>
                <MessageCircle size={20} />
                <span>
                  {t('chatViaKakao')}
                </span>
              </button>

              {/* Phone Call Button */}
              <button className="contact-btn phone-btn" onClick={handlePhoneCall}>
                <Phone size={20} />
                <span>
                  {t('callAdmin')}
                  <small className="phone-number">{ADMIN_PHONE}</small>
                </span>
              </button>
            </div>
          </div>

          {/* Back Button */}
          <button className="btn-back-home" onClick={() => navigate('/')}>
            {t('backToHome')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
